export default {
  beforeCreate() {
    this.$store.dispatch('setReadyState', false)
  },
  mounted() {
    this.$gtag.pageview(this.$route)
    const self = this
    const _isReady = () => {
      this.$store.dispatch('setReadyState', true)
      self.setup
        ? self.setup()
        : console.log(
            '%c Warning! No setup method in component. ',
            'font-weight: bold; color: red'
          )
    }
    if (this.$store.state.ready) {
      console.log('%c Ready from before', 'font-weight: bold; color: green')
      return
    }

    Promise.all([
      this.$store.dispatch('getFeaturedSpecies'),
      this.$store.dispatch('getSubCategories'),
      this.$store.dispatch('getAllSpieces'),
      this.$store.dispatch('getFacts'),
      this.$store.dispatch('GetSpecEnv'),
      this.$store.dispatch('prefetchPage', 281),
      this.$store.dispatch('prefetchPage', 3534),
      this.$store.dispatch('prefetchPage', 3535),
      this.$store.dispatch('prefetchPage', 3536),
      this.$store.dispatch('prefetchPage', 3537),
      this.$store.dispatch('prefetchPage', 3496),
      this.$store.dispatch('prefetchPage', 3499),
      this.$store.dispatch('prefetchPage', 3500),
      this.$store.dispatch('prefetchPage', 3498),
      this.$store.dispatch('prefetchPage', 3497),
      this.$store.dispatch('prefetchPage', 3530),
      this.$store.dispatch('prefetchPage', 3580),
      this.$store.dispatch('prefetchPage', 3682),
      this.$store.dispatch('prefetchPage', 3685),
      this.$store.dispatch('prefetchPage', 3683),
      this.$store.dispatch('prefetchPage', 3262),
      this.$store.dispatch('prefetchPage', 3700)
    ]).then(_ => {
      _isReady()
      console.log('%c Ready, fetched', 'font-weight: bold; color: green')
    })
  },
  computed: {
    $_loading() {
      return !this.$store.state.ready
    }
  }
}
